var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.26035 12.1841C-0.0867832 11.837 -0.0867832 11.2742 0.26035 10.927L7.37146 3.81592C7.71859 3.46879 8.28141 3.46879 8.62854 3.81592L15.7397 10.927C16.0868 11.2742 16.0868 11.837 15.7397 12.1841C15.3925 12.5312 14.8297 12.5312 14.4826 12.1841L8 5.70154L1.51743 12.1841C1.1703 12.5312 0.607482 12.5312 0.26035 12.1841Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse_icon.29680ac2b4d00c3f266ff97dad645b74.svg";
export { ForwardRef as ReactComponent };